export default "__VITE_ASSET__XBmeOKm6__"